var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.001,
    viewBox: "0 0 20.001 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4782",
    "data-name": "Group 4782",
    transform: "translate(-29.999 -151.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "categories",
    d: "M11.6,4.4V10A1.6,1.6,0,0,1,10,11.6H4.4A1.6,1.6,0,0,1,2.8,10V4.4A1.6,1.6,0,0,1,4.4,2.8H10A1.6,1.6,0,0,1,11.6,4.4Zm9.6-1.6H15.6A1.6,1.6,0,0,0,14,4.4V10a1.6,1.6,0,0,0,1.6,1.6h5.6A1.6,1.6,0,0,0,22.8,10V4.4A1.6,1.6,0,0,0,21.2,2.8ZM10,14H4.4a1.6,1.6,0,0,0-1.6,1.6v5.6a1.6,1.6,0,0,0,1.6,1.6H10a1.6,1.6,0,0,0,1.6-1.6V15.6A1.6,1.6,0,0,0,10,14Zm8.4,0a4.4,4.4,0,1,0,4.4,4.4A4.4,4.4,0,0,0,18.4,14Z",
    transform: "translate(27.199 149.199)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4605",
    "data-name": "Rectangle 4605",
    width: 20,
    height: 20,
    transform: "translate(30 152)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.37f5b664697aeff6e4a6ed7d7a8472c4.svg";
export { ForwardRef as ReactComponent };